<div class="create-coding-ques-view content">

    <div class="heading">
        <div>{{data.update ? 'Update' : 'Add New'}} Coding Question</div>
        <mat-icon aria-hidden="false" aria-label="close icon" class="close-icon" (click)="cancel()">close</mat-icon>
    </div>
    <form [formGroup]="createCodingQuesFrom" mat-dialog-content>
        <div class="time-limit-level-section">
            <div class="time-limit">
                <label class="label-txt">TIME LIMIT RECOMMENDED </label>
                <mat-form-field appearance="outline" class="time-form-field">
                    <mat-label>Hours</mat-label>
                    <mat-select formControlName="hourLimit" (selectionChange)="minuteOrHourLimitChange($event)">
                        <mat-option *ngFor="let hour of hours" [value]="hour">{{hour}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="time-form-field">
                    <mat-label>Mins</mat-label>
                    <mat-select formControlName="minLimit" (selectionChange)="minuteOrHourLimitChange($event)">
                        <mat-option *ngFor="let min of minutes" [value]="min">{{min}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="d-level">
                <label class="label-txt">DIFFICULTY LEVEL </label>
                <mat-form-field appearance="outline" class="level-form-field">
                    <mat-label>Levels</mat-label>
                    <mat-select formControlName="difficultyLevel">
                        <mat-option *ngFor="let level of difficultyLevels" [value]="level.id">{{level.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="editor-section">
            <angular-editor formControlName="questionText" [config]="codingEditorConfig" id="codingConfig">
            </angular-editor>
        </div>
        <div class="language-selection">
            <mat-form-field appearance="outline" class="fname-form-field">
                <mat-select formControlName="languages" panelClass="lang-select" placeholder="Coding Language"
                    (selectionChange)="onLanguageSelection($event)" [(value)]="dropdownSelctedLangs"
                    (openedChange)="openCloseLangSelect($event)" multiple>
                    <mat-option *ngFor="let lang of codingLanguages" [value]="lang" [disabled]="dropdownSelctedLangs?.length > 0  && 
                            dropdownSelctedLangs?.indexOf(lang) >= 0">
                        {{lang.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="selcted-lan-list">
            <mat-chip-listbox aria-label="Dog selection">
                <mat-chip-option *ngFor="let language of dropdownSelctedLangs; let i= index"
                    (click)="languageSelect({value: language, idx:i})" [ngClass]="{'active-item': langCode?.id === language?.id, 
                        'success-item': language?.isQuestionAdded}" [selected]="langCode?.id === language?.id"
                    [selectable]="'false'">
                    {{language.name}}
                    <button matChipRemove class="remove-icon" (click)="deleteSelectedLanguage(language)">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-option>
            </mat-chip-listbox>
        </div>
        <!-- coding editor -->
        <mat-tab-group dynamicHeight mat-stretch-tabs class='coding-question-tab-group' #questionsTabGroup
            [selectedIndex]="activeTabIndex" (selectedTabChange)="tabChanged($event)">
            <mat-tab label="Function Signature">
                <div class="steps">
                    <div class="item current-step"> Step 1 </div>
                    <div class="item"></div>
                    <div class="item"></div>
                    <div class="item"></div>
                </div>
                <div class="function-signature" formGroupName="functionSignature">
                    <div class="function-details">
                        <mat-form-field appearance="outline" class="fname-form-field">
                            <mat-label>Function Name</mat-label>
                            <input matInput placeholder="Function Name" formControlName="function_name" required>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="return-form-field">
                            <mat-label>Returns</mat-label>
                            <mat-select formControlName="return_type" required>
                                <mat-option *ngFor="let returnVal of returnTypes" [value]="returnVal.id">
                                    {{returnVal.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="param-section" formArrayName="code_params">
                        <label class="label">Parameters</label>
                        <div *ngFor="let param of params.controls; let i = index" class="param-row" [formGroupName]="i">
                            <div class="name-type-sec">
                                <mat-form-field appearance="outline" class="pname-form-field">
                                    <mat-label>Name</mat-label>
                                    <input matInput type="text" formControlName="param" placeholder="Enter param">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="type-form-field">
                                    <mat-label>Type</mat-label>
                                    <mat-select formControlName="type">
                                        <mat-option *ngFor="let returnval of returnTypes" [value]="returnval.id">
                                            {{returnval.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <button mat-icon-button (click)="removeParam(i)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                    <button mat-stroked-button color="primary" (click)="addParam()" class="add-param">
                        <mat-icon>add_circle_outline</mat-icon>
                        <span>Add new parameter</span>
                    </button>
                </div>

                <div class="topics-tags-sec">
                    <div class="topic-form-field">
                        <label class="label-txt">TOPICS </label>
                        <ng-multiselect-dropdown appFocusOnClick [placeholder]="'Select a topic...'"
                            [settings]="topicsSettings" [data]="topics" formControlName="topics"
                            class="coding-topics-multiselect">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="topic-form-field">
                        <mat-label class="label-txt">TAGS</mat-label>
                        <mat-form-field class="tags-form-field">
                            <mat-chip-grid #chipList aria-label="Tag selection">
                                <mat-chip-row *ngFor="let tag of tags" (removed)="removeTag(tag)">
                                    {{tag.name}}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-row>
                                <input placeholder="New tag..." formControlName="tags" [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTag($event)">
                            </mat-chip-grid>
                        </mat-form-field>
                    </div>
                </div>

            </mat-tab>

            <mat-tab label="Initial Code">
                <div class="steps">
                    <div class="item"></div>
                    <div class="item current-step"> Step 2 </div>
                    <div class="item"></div>
                    <div class="item"></div>
                </div>
                <div class="initial-code-tab">
                    <div class="app-ace-editor" #editor></div>
                </div>
            </mat-tab>

            <mat-tab label="Test Cases">
                <div class="steps">
                    <div class="item"></div>
                    <div class="item"></div>
                    <div class="item current-step"> Step 3 </div>
                    <div class="item"></div>
                </div>
                <div class="test-cases-section" formArrayName="testCases">
                    <div class="title">Test cases to be used during the test</div>

                    <mat-accordion multi="true" class="test-case-accordion">
                        <mat-expansion-panel class="test-expansion-panel"
                            *ngFor="let testCase of testCases?.controls; let i = index" [formGroupName]="i"
                            #mep="matExpansionPanel">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span>
                                        {{createCodingQuesFrom.value.testCases[i].name}}
                                    </span>
                                </mat-panel-title>
                                <mat-panel-description>
                                    {{getMethodWithArguments(i)}}
                                </mat-panel-description>
                                <button mat-icon-button (click)="deleteTestCase(i)" class="test-case-delete-icon">
                                    <mat-icon>highlight_off</mat-icon>
                                </button>
                            </mat-expansion-panel-header>

                            <div class="test-case-item">
                                <mat-form-field appearance="outline" class="test-case-name">
                                    <mat-label>Name</mat-label>
                                    <input matInput type="text" formControlName="name" placeholder="Enter param">
                                </mat-form-field>
                                <div class="test-case-param-sec" formArrayName="testParams">
                                    <div
                                        *ngFor="let item of createCodingQuesFrom.controls['testCases']['controls'][i]?.controls?.testParams?.controls; let j = index;">
                                        <div [formGroupName]="j">
                                            <mat-form-field class="test-case-param" appearance="outline">
                                                <mat-label>
                                                    {{createCodingQuesFrom?.value?.functionSignature?.code_params[j]?.param}}
                                                </mat-label>
                                                <input matInput placeholder="Enter input"
                                                    type="{{ (numberTypes[createCodingQuesFrom?.value?.functionSignature?.code_params[j]?.type]) ? 'number' :'text'}}"
                                                    formControlName="testParamValue">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <mat-form-field appearance="outline" class="test-case-result">
                                    <mat-label>Output</mat-label>
                                    <input matInput type="text" formControlName="output" placeholder="Enter param">
                                </mat-form-field>
                            </div>
                            <button mat-stroked-button color="primary" (click)="mep.expanded = false;"
                                [disabled]="!testCases?.controls[i].valid" class="add-test-case">
                                <span>Add</span>
                            </button>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <button mat-stroked-button color="primary" (click)="addNewCase()" class="add-test-case">
                        <mat-icon>add_circle_outline</mat-icon>
                        <span>Add new</span>
                    </button>
                </div>

            </mat-tab>

            <mat-tab label="Verification Code">
                <div class="steps">
                    <div class="item"></div>
                    <div class="item"></div>
                    <div class="item"></div>
                    <div class="item current-step"> Step 4 </div>
                </div>

                <div class="verification-code-tab">
                    <div class="app-ace-editor" #verifyCodeEditor></div>
                </div>
                <div class="test-output">
                    <div class="test-output-header">
                        <h4 class="test-header-title">Test output</h4>
                        <ng-container *ngIf="runCompleted">
                            <div class="test-header-ok-title">Success: {{runTestResult?.success || 0}}</div>
                            <div class="test-header-error-title">Failed: {{runTestResult?.failure || 0}}</div>
                            <div class="test-header-error-title" *ngIf="runTestResult?.errored">Error:
                                {{runTestResult?.errored || 0}}</div>
                            <div class="test-header-title">Total: {{runTestResult?.success + runTestResult?.failure +
                                runTestResult?.errored}}</div>
                        </ng-container>
                        <button mat-flat-button [disabled]="!getFormValid()" color="primary" class="mat-focus-indicator mat-run-accent-btn
                            mr-16 mat-condensed-button mat-flat-button mat-button-base" (click)="runTestCases()">
                            <span class="mat-button-wrapper">
                                <mat-icon class="mat-icon notranslate 
                                            material-icons mat-icon-no-color" data-mat-icon-type="font">
                                    play_arrow
                                </mat-icon>
                                <span>Run Test</span>
                            </span>
                        </button>
                    </div>

                    <div class="html-content">
                        <p test-header-title>{{runTestResult?.errorMessage || 'Check output here.'}} </p>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </form>

    <div class="actions">
        <button mat-flat-button color="primary" *ngIf="activeTabIndex !== 3" (click)="gotoNextStep()">
            Next Step
        </button>
        <button mat-flat-button color="primary" *ngIf="activeTabIndex === 3"
            [disabled]="!createCodingQuesFrom.valid || !runCompleted" (click)="addOrUpdateQuestion()">
            {{data.update ? 'Update Question' : 'Add Question'}}
        </button>
    </div>

</div>